module.exports = __webpack_public_path__ + "static/logo-brightmike-847867a4218c36bcef853ec90db5331e.png";